"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pollerActions = require("angieslist-app-platform/lib/common/poller/pollerActions");
var _angieslistAppPlatform = require("angieslist-app-platform");
var _uuid = _interopRequireDefault(require("uuid"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  beforeConfigureStore: function beforeConfigureStore(options) {
    var ionOptions = {
      reducers: _objectSpread(_objectSpread({}, (options || {}).reducers), {}, {
        memberFaq: require('./modules/common/reducers/memberFaqReducer'),
        memberFaqUI: require('./modules/common/reducers/memberFaqUIReducer'),
        memberManagementGateway: require('./modules/common/reducers/memberMgmtGatewayReducer'),
        serviceProviderGateway: require('./modules/common/reducers/serviceProviderGatewayReducer'),
        myAccountUI: require('./modules/common/reducers/myAccountUIReducer')
      })
    };
    return ionOptions;
  },
  afterConfigureStore: function afterConfigureStore(store) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    store.dispatch((0, _pollerActions.getConfig)());
    var appName = (0, _get2["default"])(store.getState(), 'config.appName');
    var appVersion = (0, _get2["default"])(store.getState(), 'config.appVersion');
    _angieslistAppPlatform.httpClient.addInterceptor({
      request: function request(_request) {
        _request.headers.set('X-ANGI-ProxyVersion', '1');
        _request.headers.set('X-ANGI-RequestId', _uuid["default"].v1());
        _request.headers.set('X-ANGI-SourceApplication', appName);
        _request.headers.set('X-ANGI-ApplicationVersion', appVersion);
        return _request;
      }
    });
  }
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/injectors.js
// module id = 4390
// module chunks = 9